import React from 'react';
import { Typography } from '@mui/material';
import { QuestionCard } from '../QuestionCard';
import { QuestionLabel } from '../QuestionLabel';
import { StyledTextField } from '../StyledTextField';
import { ScrollableChipSelector } from '../../ScrollableChipSelector';
import { colors } from '../../../../theme';

interface ChipSelectorQuestionProps {
  label: string;
  description?: string;
  chips: string[] | [string, string][];
  selectedValue: string;
  customValue: string;
  onSelectedChange: (value: string) => void;
  onCustomChange: (value: string) => void;
  placeholder: string;
  helperText?: string;
}

export const ChipSelectorQuestion: React.FC<ChipSelectorQuestionProps> = ({
  label,
  description,
  chips,
  selectedValue,
  customValue,
  onSelectedChange,
  onCustomChange,
  placeholder,
  helperText
}) => {
  return (
    <QuestionCard>
      <QuestionLabel>
        {label}
      </QuestionLabel>
      {description && (
        <Typography
          sx={{
            fontSize: '0.875rem',
            color: colors.slate[600],
            marginBottom: '16px',
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      )}
      <ScrollableChipSelector
        chips={chips}
        value={selectedValue}
        onChange={onSelectedChange}
      />
      <StyledTextField
        value={customValue}
        onChange={onCustomChange}
        placeholder={placeholder}
        rows={3}
        helperText={helperText}
      />
    </QuestionCard>
  );
};
